import type { MigrationStrategies } from "./_types/migration-strategies";

// v0 → v1: switch from random uuid `id` to a deterministic, collision-safe
// id keyed by `(userId, key, version)` — see `deterministic-ids.ts → dismissalId`
// for the length-prefix encoding — so double-clicks and multi-device
// dismissals dedupe on upsert. Drop v0 rows locally; next pull from
// api-admin gives them back and the mapper rewrites to the new id.
export const NOTIFICATION_DISMISSAL_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: () => null,
    // v1 → v2: id maxLength widened to 440 (covers the length-prefix encoded
    // composite — see `deterministic-ids.ts → dismissalId`) and
    // `versionAtDismissal` capped at 100 chars so the composite id can't
    // exceed the new id cap. Identity transform.
    2: (oldDoc) => oldDoc,
  };
